import {cn} from '@/lib/utils'
import {IWuAppHeaderBreadcrumbItem} from '../../types/WuAppHeaderBreadcrumbItem'
import {WuAppHeaderBreadcrumb} from './WuAppHeaderBreadcrumb'

export interface IWuAppHeaderBarProps {
  breadcrumbs?: IWuAppHeaderBreadcrumbItem[]
  children?: React.ReactNode
  dir?: 'ltr' | 'rtl'
}

export const WuAppHeaderBar: React.FC<IWuAppHeaderBarProps> = ({
  breadcrumbs,
  children,
  dir,
}) => {
  return (
    <section
      className={cn(
        'flex items-center flex-1 min-w-0 h-12 gap-2 px-2',
        dir === 'rtl' && 'flex-row-reverse',
      )}
    >
      {breadcrumbs && breadcrumbs?.length > 0 && (
        <div className="overflow-hidden text-ellipsis whitespace-nowrap max-w-[60%] shrink-0">
          <WuAppHeaderBreadcrumb breadcrumbs={breadcrumbs} dir={dir} />
        </div>
      )}
      <div className="grow">{children}</div>
    </section>
  )
}
